module.exports = __webpack_public_path__ + "img/1544659929.63c9402e.jpg";